// import BrowserDtector from 'browser-dtector';
import { sha256 } from 'js-sha256';
import {campaign} from "@/vars";

function sendApplication(lead, registry) {
    let application = {}

    let products = [lead.productActive]

    if (lead.crossselling !== '') {
        products.push(lead.crossselling.toString() )
    }

    if (lead.combi !== '') {
        products.push(lead.combi.toString() )
    }

    application.broker_id = (lead.brokerID !== undefined)? lead.brokerID: "";
    application.sub_broker_id = (lead.subBrokerID !== undefined)? lead.subBrokerID: "";

    if (lead.referenceID) {
        application.referenceID = lead.referenceID
    }

    if (lead.campaignID) {
        application.campaignID = lead.campaignID
    }

    if (lead.hash) {
        application.hash = lead.hash
        application.reSend = true
        lead.hash = undefined

    }
//###########
    let gender = "female"

    switch(lead.gender) {
        case 'Herr':
            gender = 'male'
            break
        case 'Divers':
            gender = 'divers'
            break
        case 'Herr und Frau':
            gender = 'male-female'
            break
        case 'Firma':
            gender = 'company'
            break
        case 'Frau und Herr':
            gender = 'female-male'
            break
        case 'Frau und Frau':
            gender = 'female-female'
            break
        case 'Herr und Herr':
            gender = 'male-male'
            break
        case 'Eheleute':
            gender = 'couple'
            break
        case 'Familie':
            gender = 'family'
            break
    }

    const zeroPad = (num, places) => String(num).padStart(places, '0')

    let cusDate = new Date(lead.birthday)
    let cusDateString = cusDate.getFullYear() + '-' + zeroPad((cusDate.getMonth()+1), 2) + '-' + zeroPad(cusDate.getDate(), 2)

    application.customer = {
        "gender": gender,
        "firstname": lead.firstname,
        "lastname": lead.lastname,
        "email": lead.email,
        "phone": lead.phone.replace(/[\uE000-\uF8FF]/g, ''),
        "birthdate": cusDateString,
        "address": {
            "street": lead.street,
            "nostreetnumber": lead.numberN,
            "streetnumber": lead.number,
            "zipcode": lead.zip,
            "city": lead.city,
            "country": (lead.country == "Deutschland")? "DE": "AT"
        }
    }

    let petDate = new Date(lead.petbirthday)
    let petDateString = petDate.getFullYear() + '-' + zeroPad((petDate.getMonth() + 1), 2) + '-' + zeroPad(petDate.getDate(), 2)

    let colours = registry.catcolourByName
    let petrace = 'cat'

    if (lead.race == "1") {
        colours = registry.dogcolourByName
        petrace = 'dog'
    }

    let breeds = registry.dogbreedsByName

    if(lead.race == 2) {
        breeds = registry.catbreedsByName
    }

    if (breeds[lead.breed] && breeds[lead.breed].breed_id) {
        lead.breed_id = breeds[lead.breed].breed_id
    }

    application.animal = {
        "name": lead.petname,
        "birthdate": petDateString,
        "gender": (lead.petgender == "1")? "male": "female",
        "purebred": true,
        "breed_id_1st": lead.breed_id,
        "animal_type": petrace,
        "color": lead.petcolour,
        "color_number": colours[lead.petcolour],
    }

    application.payment = setPayment(lead)
    application = oldContract(lead, application)

    // carefull
    application.causeError = true

    const path =  process.env.VUE_APP_API_ENDPOINT_PRD + 'application'
    const returner = []
    let iter = 0
    let seconds = calcAgeInSeconds(lead.petbirthday)
    let productPrice = 0
    let items = []

    application.isCrossselling = []

    /////////////////////////////////////
    if (products.length > 1) {
        application.isCrossselling = products
    }

    if (campaign) {
        application.marketingcampaign = campaign;
    }

    application.symptoms = [];
    if (lead.symptomElements && lead.symptomElements.length) {
        lead.symptomElements.forEach(symptom => {
            application.symptoms.push(Number(symptom.id)) ;
        });
    } else if (lead.symptoms) {
        application.symptoms = lead.symptoms;
    }
    application.pre_conditions = [];
    if (lead.healthElements && lead.healthElements.length) {
        lead.healthElements.forEach(healthElement => {
            application.pre_conditions.push({
                id: healthElement.preCondition.zvk_identifier,
                treatment_status: Number(healthElement.status),
                occurrence: Number(healthElement.occurrence),
                additional_information: healthElement.description
            })
        })
    } else if (lead.pre_conditions) {
        application.pre_conditions = lead.pre_conditions
    }

    let iter1 = 0

    for (let i of products) {
        iter1++
        application.lead_id = setLeadID(i, lead, registry)

        let sub = registry.productByID[i].abbreviation.substring(0, 2)

        if ((sub == 'TK' || sub == 'OP')) {
            application.symptoms = [];
            if (lead.symptomElements && lead.symptomElements.length) {
                lead.symptomElements.forEach(symptom => {
                    application.symptoms.push(Number(symptom.id)) ;
                });
            } else if (lead.symptoms) {
                application.symptoms = lead.symptoms;
            }
            application.pre_conditions = [];
            if (lead.healthElements && lead.healthElements.length) {
                lead.healthElements.forEach(healthElement => {
                    application.pre_conditions.push({
                        id: healthElement.preCondition.zvk_identifier,
                        treatment_status: Number(healthElement.status),
                        occurrence: Number(healthElement.occurrence),
                        additional_information: healthElement.description
                    })
                })
            } else if (lead.pre_conditions) {
                application.pre_conditions = lead.pre_conditions
            }
        } else {
            application.symptoms = [];
            application.pre_conditions = [];
        }

        if (iter1 == 2 && (sub == 'TK' || sub == 'OP')) {
            const today = new Date()
            const tomorrow = new Date(today)
            tomorrow.setDate(tomorrow.getDate() + 1)
            lead.startDate = tomorrow.toISOString().split('T')[0]
        }

        application.tariff = setTarriff(i, lead, registry)

        try {
            if (document.cookie.match('(^|;)\\s*telljaid\\s*=\\s*([^;]+)') && sub == 'TK') {
                application.customer_campaign = {
                    supplier_name: "tellja",
                    id: document.cookie.match('(^|;)\\s*telljaid\\s*=\\s*([^;]+)')[2]
                };
                application.broker_id = '1745137';
            } else {
                application.customer_campaign = undefined;
                application.broker_id = (lead.brokerID !== undefined)? lead.brokerID: "";
            }
        } catch (e) {
            console.error(e)
        }

        let xhr = new XMLHttpRequest();
        xhr.open('POST', path, false)
        xhr.send(JSON.stringify(application))
        let json = JSON.parse(xhr.response)

        returner[iter] = {'product': i, 'status': json}

        if ( returner[iter]['status'][1] == 200) {
            returner['isOK'] = true
        }
        else {
            returner['isOK'] = false
            return returner[iter]['status'][1];
        }


        // const browser = new BrowserDtector(window.navigator.userAgent);
        // let ua = browser.parseUserAgent();
        //
        // let data = [
        //     {
        //       index: 'agila-leads',
        //       value: 1,
        //       tags: {
        //         leadID: application.lead_id, // kürzen auf Anfang
        //         version: 1,
        //         browserName: ua.name,
        //         userAgent: ua.userAgent,
        //         platform: ua.platform,
        //         browserVersion: ua.version,
        //         mobile: ((ua.isMobile)? 'mobile': (ua.isTablet)? 'tablet': 'desktop'),
        //        // useragent: navigator, // navigator infos einzeln
        //       //  tariff: application.tariff,
        //         petBirthdate: application.animal.birthdate,
        //         petGender: application.animal.gender,
        //         breed_id_1st: lead.breed_id,
        //         petType: petrace,
        //         healthy: !lead.treatmentBase && (!lead.symptomElements || lead.symptomElements.length === 0),
        //         country: application.customer.country,
        //         broker_id: application.broker_id,
        //         referenc_id: application.sub_broker_id,
        //         product_name: application.tariff.name,
        //         start_date: application.tariff.start_date,
        //         paymentperiod: application.tariff.paymentperiod
        //
        //         //plz
        //         }
        //     }
        //   ]


        // fetch(process.env.VUE_APP_COMMON_API_URL + 'metrics', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //         'Client-Key': process.env.VUE_APP_COMMON_API_KEY
        //     },
        //     body: JSON.stringify(data)
        // });

        iter++;


        let matrix = getMatrix(lead, registry, i);
        productPrice = calcPrice(matrix, seconds)

        items.push ({id: registry.productByID[i].abbreviation,
            name: registry.productByID[i].idd_name,
            category: 'lead',
            variant: '',
            //step: 5,
            list_position: 1,
            quantity: 1,
            price: +productPrice})

    }

// Health answers
    if (lead.symptomElements || lead.treatmentBase) {
        let symptoms = [];
        if (lead.symptomElements && lead.symptomElements.length) {
            lead.symptomElements.forEach(symptom => {
                symptoms.push(Number(symptom.id)) ;
            });
        }
        let treatments = [];
        if (lead.healthElements && lead.healthElements.length) {
            lead.healthElements.forEach(healthElement => {
                treatments.push({
                    id: healthElement.preCondition.id,
                    treatment_status: Number(healthElement.status),
                    occurrence: Number(healthElement.occurrence),
                    additional_information: healthElement.description
                })
            })
        }

        lead.symptomElements = []
        lead.healthElements = []
    }

    if (lead.file != '') {
        let dirtyPath = process.env.VUE_APP_API_ENDPOINT_PRD.split('rest')
        dirtyPath[0] += 'dirtyAPI.php'

        let fileData = {fileContent: lead.file, fileInfo: lead.fileInfo, fileName: lead.firstname + '_' + lead.lastname + '_' + lead.petname + '_' + petDateString}

        fetch(dirtyPath[0], {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'no-cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit

            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
           // body: JSON.stringify(data) // body data type must match "Content-Type" header
             body: JSON.stringify(fileData)
          })
          .then((response) => response.json())
          .then((responseData) => {
            console.log(responseData)
          })

    }

    if (lead.newsletter == true) {
        let list = []

        if(lead.race == 1) {
            list.push(214)
        }
        else {
            list.push(215)
        }


        let data = new URLSearchParams();
        data.append('email', lead.email);
        data.append('anrede', lead.gender);
        data.append('vorname', lead.firstname);
        data.append('nachname', lead.lastname);
        data.append('lists', JSON.stringify(list));



       // fetch('https://devel.vc24.dev/index.php?option=com_inxmail&task=api.createNewsletterUser', {
        fetch(process.env.VUE_APP_INXMAIL_URL, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'no-cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit

            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
           // body: JSON.stringify(data) // body data type must match "Content-Type" header
             body: data
          })


    }
       /*user

tokenid

email

list (json)*/
    lead.isUDSelling = false


    return returner
}

/**
 * calculates the set-number
 * @param {*} lead
 * @param {*} registry
 * @returns
 */
function setLeadID (productId, lead, registry) {
    let product = registry.productByID[productId].abbreviation.substring(0, 2)
    let time = new Date().getTime()
    let name = lead.firstname.substring(0, 2) + lead.lastname.substring(0, 2)
    return product + "_" +  time + "_" + name
}

function setPayment (lead) {

    let app = {
        "type": (lead.paymentType == "ls")? "debit": "invoice",
    }

    if (lead.iban != '') {
        app.bank_data = {
            "iban": lead.iban,
            "sepa": lead.sepa
        }
    }

    return app
}

function setTarriff (productId, lead, registry) {
    const period = {"1": "month", "12": "year"}

    let app = {
        "name": registry.productByID[productId].title,
        // "start_date": setDate(lead.startDate),
        "start_date": setDate2(lead.startDate, registry),
        "paymentperiod": period[lead.paymentinterval],
        "contract_agreement": setContractAddagreement(lead),
        "serial_nr" : (sha256.hex(lead.firstname + lead.lastname + lead.petname)) + lead.race.toString(),
        "date_time": new Date().toString()
      // "marker": "old"
    }

    if (registry.productByID[productId].no_damage_question == "1" || registry.productByID[productId].require_vet == "1") {
        app.product_dependent = {}

        if (registry.productByID[productId].no_damage_question == "1") {
            app.product_dependent.previous_damage = ''
        }
    }


    if (registry.productByID[productId].no_damage_question == 1) {
        app.product_dependent = {previous_damage : (lead.noPre == true)? 'yes':'no'}
    }

    if (registry.productByID[productId].require_vet == 1) {
        app.product_dependent.vet = {
            name: lead.vetname,
            street: lead.vetstreet,
            streetnumber: lead.vetnumber,
            zipcode: lead.vetzip,
            city: lead.vetcity,
            country: (lead.vetcountry == 'Deutschland')? 'DE':'AT'
        }

    }

    return app
}

function setContractAddagreement(lead) {
    let output = '';
    let part = '';
    let counter = 0;

    if (lead.newsletter == true) {
        if(lead.race == 1) {
            output = 'NL_HUND';
        }
        else {
            output = 'NL_KATZE';
        }
        part = '_';
        counter++;
    }

    if (lead.survey == true) {
        output = output + part + 'NPS';
        part = '_';
        counter++;
    }

    if (lead.addagreement == true) {
        output = output + part + 'TEL_SMS';
        counter++;
    }

    if (counter == 1) {
        output = 'NUR_' + output;
    }

    return output || 'KEINE';
    /*"
    "NUR_NL_KATZE"
    "NL_KATZE_NPS"
    "NL_KATZE_NPS_TEL_SMS",
    "NL_KATZE_TEL_SMS",
    "NUR_NL_HUND",
    "NL_HUND_NPS",
    "NL_HUND_NPS_TEL_SMS",
    "NL_HUND_TEL_SMS",
    "NL_UMFRAGE_TEL_SMS",
    "NUR_NPS",
    "NUR_TEL_SMS",*/
}

function setDate(date) {
    let d = new Date(date)

    let testdate1 = new Date();
    testdate1.setHours(0, 0, 0, 0);
    testdate1.setDate(testdate1.getDate() -1);
    testdate1 = testdate1.getTime();

    let testdate = new Date(date)
    testdate.setHours(0, 0, 0, 0);
    testdate = testdate.getTime();

    if (testdate1 === testdate){
        d.setDate(d.getDate() + 2)
    }

    return d.toISOString().split('T')[0]
}

function setDate2(date, registry) {
    let d = new Date(date)

    let testdate1 = new Date(registry.date);

    testdate1.setHours(0, 0, 0, 0);
    testdate1.setDate(testdate1.getDate());
    testdate1 = testdate1.getTime();

    let testdate = new Date(date)

    testdate.setHours(0, 0, 0, 0);
    testdate = testdate.getTime();

    if (testdate1 > testdate){
        d = new Date(registry.date)
    }

    return d.toISOString().split('T')[0]
}
/*$this->addElement($xml, 'Name', trim($vetArray['name']), $vetData);
$this->addElement($xml, 'Strasse', trim($vetArray['street']), $vetData);
$this->addElement($xml, 'Hausnummer', trim($vetArray['streetnumber']), $vetData);
$this->addElement($xml, 'Postleitzahl', trim($vetArray['zipcode']), $vetData);
$this->addElement($xml, 'Stadt', trim($vetArray['city']), $vetData);
$this->addElement($xml, 'Land', trim(!empty($this->data->country)?$vetArray['country']:'DE'), $vetData);
this.leadin.vetname = this.vetname
this.leadin.vetstreet = this.vetstreet
this.leadin.vetnumber = this.vetnumber
this.leadin.vetzip = this.vetzip
this.leadin.vetcity = this.vetcity

$this->data->tariff->product_dependent->vet;*/

function calcPrice(agePriceList, seconds) {
    var priceObj = '';
      var sec = 1000000000;

      for (var secs in agePriceList) {
        if (secs >= seconds && secs < sec) {
            priceObj = agePriceList[secs]
            sec = secs;
            break;
        }
      }

      var price = priceObj.price;

      if (priceObj.type == 1) {
          price = (price / 12).toFixed(2);
      }

      return price
  }
function calcAgeInSeconds(birthdate) {
    var t1 = new Date()
    var t2 = new Date(birthdate)
    var diff = (t1.getTime() - t2.getTime()) /1000

    return Math.round(diff)
  }
function getMatrix(lead, registry, id) {
    const race = ['', 'dog', 'cat']
    const product = registry.productByID[id]

    let matrix = [];
    let breeds = registry.dogbreedsByName

    if(lead.race == 2) {
      breeds = registry.catbreedsByName
    }

    const breed_class_id = lead.race == 1 && lead.breed ? breeds[lead.breed].breed_class_id: 1;
    lead.breed_class_id = breed_class_id

    if (registry.productMatrix[race[lead.race]][product.abbreviation]['matrix'][0] !== undefined
      && lead.race == 1 || registry.productMatrix[race[lead.race]][product.abbreviation]['matrix'][1] === undefined) {
      matrix = registry.productMatrix[race[lead.race]][product.abbreviation]['matrix'][0]
    }
    else {
      matrix = registry.productMatrix[race[lead.race]][product.abbreviation]['matrix'][lead.breed_class_id]
    }

    return matrix
}

function oldContract(lead, application) {
    //
    lead.doContract = false

    if (lead.policy_id != undefined) {
        application.contract = {
            policy_id: lead.policy_id,
            contract_id: lead.contract_id,
            object_id: lead.object_id,
            risk_id: lead.risk_id,
            exposure_id: 'x'
            //type:
        }
        lead.doContract = true
    }

    lead.policy_id = lead.contract_id = lead.object_id = lead.risk_id = undefined


    return application
}

export {
    sendApplication,
    setDate
}
